<template>
  <r-panel :title="title">
    <v-card width="100%" class="ma-0 pa-2" elevation="0" outlined>
      <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
        <v-card-title class="orange--text pa-0 ma-0 ml-1">Product Track</v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon elevation="0" color="white" dense class="green--text" @click="row_add()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions width="100%" class="ma-0 pa-1" elevation="0">
        <v-data-table
            :headers="headers"
            :items="value.products"
            :height="value.products && value.products.length > 7 ? (32 * 7 + 32 + 16) : undefined"
            item-key="none"
            disable-pagination
            hide-default-footer
            dense
            style="white-space: nowrap; width: 100%;">
          <template v-slot:item.product="{item}">
            {{ getProductName(item.product) }}
          </template>
          <template v-slot:item.points="{item}">
            {{ item.points }}
          </template>
          <template v-slot:item.actions="{item, index}">
            <v-icon @click="row_edit(index)" class="mr-2" small>mdi-pencil</v-icon>
            <v-icon @click="row_moveup(index)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
            <v-icon @click="row_movedown(index)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
            <v-icon @click="row_remove(index)" class="mr-2" small>mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>

    <!-- Product Edit Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editIndex === -1 ? 'Add Product' : 'Edit Product' }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              v-model.number="editItem.points"
              label="Points"
              type="number"
              outlined
              dense
          />
          <r-product-dropdown
              :model.sync="editItem.product"
              :groups="product_groups"
              label="Product"
              outlined
              dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ProductTrackModel} from "@/modules/redactor/models/product/ProductTrackModel";
import {ProductTrackItemModel} from "@/modules/redactor/models/product/ProductTrackItemModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-product-track-panel",
  components: {RProductDropdown, RPanel},
  props: {
    title: VueTypes.string.def("Product Track"),
    model: VueTypes.instanceOf(ProductTrackModel),
  },
  data() {
    return {
      dialog: false,
      editIndex: -1,
      editItem: new ProductTrackItemModel(),
      headers: [
        { text: 'Product', value: 'product', sortable: false },
        { text: 'Points', value: 'points', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new ProductTrackModel();
        this.$emit("update:model", value);
        return value;
      }
    },
    product_groups() {
      return [ProductGroupKind.SMART_OFFERS];
    }
  },
  methods: {
    getProductName(productUid) {
      if (!productUid) return 'No Product';
      const product = RedactorUtils.getProduct(productUid);
      return product ? product.name || product.key || productUid : productUid;
    },
    row_add() {
      this.editIndex = -1;
      this.editItem = new ProductTrackItemModel();
      this.dialog = true;
    },
    row_edit(index) {
      this.editIndex = index;
      this.editItem = this.value.products[index].clone();
      this.dialog = true;
    },
    row_remove(index) {
      this.value.products.splice(index, 1);
    },
    row_moveup(index) {
      if (index === 0) {
        this.value.products.push(this.value.products.shift());
      } else {
        [this.value.products[index], this.value.products[index - 1]] = 
        [this.value.products[index - 1], this.value.products[index]];
      }
    },
    row_movedown(index) {
      if (index === (this.value.products.length - 1)) {
        this.value.products.unshift(this.value.products.pop());
      } else {
        [this.value.products[index], this.value.products[index + 1]] = 
        [this.value.products[index + 1], this.value.products[index]];
      }
    },
    save() {
      // Validate the editItem before saving
      if (!this.editItem.valid()) {
        this.$alert('Invalid product configuration');
        return;
      }
      
      if (this.editIndex > -1) {
        // Edit existing item
        Object.assign(this.value.products[this.editIndex], this.editItem);
      } else {
        // Add new item
        this.value.products.push(this.editItem);
      }
      this.close();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editItem = new ProductTrackItemModel();
        this.editIndex = -1;
      });
    }
  }
}
</script>